import { api } from './api';

export interface PurchaseSubscriptionPayload {
    plan_name: string;
    price: number;
}

export interface PurchaseSubscriptionResponse {
    success: boolean;
    message: string;
    data?: {
        payment_id?: string;
        status?: string;
        plan_name?: string;
        price?: number;
    };
}

export const purchaseSubscription = (
    token: string,
    payload: PurchaseSubscriptionPayload
): Promise<PurchaseSubscriptionResponse> =>
    api.post<PurchaseSubscriptionResponse>('/subscriptions/purchase', payload, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

export interface CreatePaymentSessionPayload {
    plan_id: number;
    plan_name: string;
    amount: number;
    first_name: string;
    last_name: string;
    email: string;
    country: string;
    address?: string;
    city?: string;
    postal_code?: string;
    phone?: string;
}

export interface CreatePaymentSessionResponse {
    success: boolean;
    message: string;
    data: {
        sessionToken: string;
    };
}

export const createPaymentSession = (
    token: string,
    payload: CreatePaymentSessionPayload
): Promise<CreatePaymentSessionResponse> =>
    api.post<CreatePaymentSessionResponse>('/subscriptions/create-payment-session', payload, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

export interface ValidateIbanPayload {
    session_token: string;
    iban: string;
}

export interface ValidateIbanResponse {
    success: boolean;
    message: string;
    data: {
        valid: boolean;
        bankName?: string | null;
        bic?: string | null;
        message?: string | null;
    };
}

export const validateIban = (
    token: string,
    payload: ValidateIbanPayload
): Promise<ValidateIbanResponse> =>
    api.post<ValidateIbanResponse>('/subscriptions/validate-iban', payload, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

export interface SubmitPaymentPayload {
    session_token: string;
    iban: string;
    iban_holder_name: string;
}

export interface PaymentFlowResponse {
    success: boolean;
    message: string;
    data: {
        sessionToken: string;
        status: string;
        retryAllowed: boolean;
        verificationUrl: string | null;
        message: string | null;
        subscriptionActive: boolean;
    };
}

export const submitPayment = (
    token: string,
    payload: SubmitPaymentPayload
): Promise<PaymentFlowResponse> =>
    api.post<PaymentFlowResponse>('/subscriptions/submit-payment', payload, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

export interface VerifyPaymentPayload {
    session_token: string;
    verification_id?: string;
}

export const verifyPayment = (
    token: string,
    payload: VerifyPaymentPayload
): Promise<PaymentFlowResponse> =>
    api.post<PaymentFlowResponse>('/subscriptions/verify-payment', payload, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

export interface UnsubscribePayload {
    email: string;
    first_name: string;
    last_name: string;
    iban_last_5: string;
}

export interface UnsubscribeResponse {
    success: boolean;
    message: string;
}

export const unsubscribeUser = (
    payload: UnsubscribePayload
): Promise<UnsubscribeResponse> =>
    api.post<UnsubscribeResponse>('/subscriptions/unsubscribe', payload);
